"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _Currency = _interopRequireDefault(require("@meepshop/context/lib/Currency"));

var _locales = require("@meepshop/locales");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// definition
var _default = function _default(adTracks, fbq) {
  var _useContext = (0, _react.useContext)(_Currency["default"]),
      currency = _useContext.currency;

  var getLanguage = (0, _locales.useGetLanguage)();
  return (0, _react.useCallback)(function (_ref) {
    var eventName = _ref.eventName,
        id = _ref.id,
        title = _ref.title,
        quantity = _ref.quantity,
        specs = _ref.specs,
        price = _ref.price,
        sku = _ref.sku;
    if (!adTracks) return;
    /** 加入購物車事件不再區分 popup or general
     * 也不用傳 event_label
     * spec: https://www.notion.so/specification/1afe5b90766180a29064f8c39ca070a4?pvs=4#1e4e5b90766180c0a971f29cb2bee2d4
     * zulip: https://zulip.meepshop.com/#narrow/stream/6-dev.2Fteam/topic/.E7.AB.8B.E5.8D.B3.E8.B3.BC.E8.B2.B7/near/1625945  */

    var googleAnalyticsId = adTracks.googleAnalyticsId;

    var _ref2 = function () {
      switch (eventName) {
        case 'upselling':
          return {
            event: 'trackCustom',
            type: 'AddToCart_AdditionalPurchase',
            label: 'AdditionalPurchase'
          };

        default:
          return {
            event: 'track',
            type: 'AddToCart',
            label: 'general'
          };
      }
    }(),
        event = _ref2.event,
        type = _ref2.type,
        label = _ref2.label;

    fbq(event, type, {
      content_ids: [id],
      content_type: 'product',
      value: price,
      currency: currency
    });

    if (window.gtag && googleAnalyticsId) {
      window.gtag('event', 'add_to_cart', _objectSpread(_objectSpread({
        currency: currency,
        value: price
      }, eventName === 'upselling' ? {
        event_label: label
      } : {}), {}, {
        items: [{
          id: id,
          name: getLanguage(title),
          variant: !specs ? '' : specs.map(function (spec) {
            return getLanguage(spec === null || spec === void 0 ? void 0 : spec.title);
          }).filter(Boolean).join('/'),
          quantity: quantity,
          price: price,
          sku: sku
        }]
      }));
    }
  }, [adTracks, fbq, currency, getLanguage]);
};

exports["default"] = _default;